import React from "react";
import PropTypes from "prop-types";
import {ExecuteOperationOnPipe, TriggerPipelineOnFormSubmit} from '@morningtrain/react-resources';
import {Pipeline} from "@morningtrain/react-helpers";
import {NavigateOnPipe, useRouter} from "@morningtrain/react-navigation";
import RefreshAuthOnPipe from "../pipes/RefreshAuthOnPipe";

function LoginPipeline(props) {

    const router = useRouter();

    return (
        <Pipeline>
            <TriggerPipelineOnFormSubmit />
            {props.beforePipes}
            <RefreshAuthOnPipe />
            {props.children}
            {!router.hasRedirectOnLoginRoute ? null : (
                <NavigateOnPipe route={router.redirectOnLoginRoute}/>
            )}
            {props.afterPipes}
        </Pipeline>
    );
}

LoginPipeline.defaultProps = {
    beforePipes: null,
    afterPipes: null,
};

LoginPipeline.propTypes = {
    beforePipes: PropTypes.node,
    afterPipes: PropTypes.node,
};

export default LoginPipeline;
